import { gql } from 'apollo-angular';

export const CREATE_LEAD = gql`
  mutation createLead($createLeadInput: CreateLeadInput!) {
    createLead(createLeadInput: $createLeadInput) {
      id
      branchID
      assignedTo
    }
  }
`;
export const UPDATE_LEAD = gql`
  mutation updateLead($id: Int!, $updateLeadInput: UpdateLeadInput!) {
    updateLead(id: $id, updateLeadInput: $updateLeadInput) {
      id
      branchID
      assignedTo
    }
  }
`;

export const REMOVE_LEAD = gql`
  mutation removeLead($id: Int!) {
    removeLead(id: $id)
  }
`;

export const CREATE_NOTES = gql`
  mutation createNotes($createNoteInput: CreateNoteInput!) {
    createNotes(createNoteInput: $createNoteInput) {
      id
      leadId
      content
      createdBy
    }
  }
`;

export const REMOVE_NOTES = gql`
  mutation removeNote($id: Int!) {
    removeNote(id: $id)
  }
`;

export const CREATE_ACTIVITY = gql`
  mutation createActivity($createActivityInput: CreateActivityInput!) {
    createActivity(createActivityInput: $createActivityInput) {
      id
      leadId
      employeeId
      details
    }
  }
`;

export const REMOVE_ACTIVITY = gql`
  mutation removeActivity($id: Int!) {
    removeActivity(id: $id)
  }
`;